import { ApplicationCode } from "constants/auth";

import Authorization from "features/authorization/Authorization";

import { RequestUpdateComponent } from "../components/RequestUpdate";

export const RequestUpdate = () => {
  return (
    <Authorization permission={[ApplicationCode.Request]}>
      <RequestUpdateComponent />
    </Authorization>
  );
};
